import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; 
import { createPinia } from 'pinia';
import { createVuetify } from 'vuetify';
import 'leaflet/dist/leaflet.css';
import 'vuetify/styles'
import * as components from 'vuetify/components';
import * as directives from "vuetify/directives";
import '@mdi/font/css/materialdesignicons.css';

const pinia = createPinia();
const vuetify = createVuetify({

    theme: {
        defaultTheme: "customTheme",
        themes: {
            customTheme: {
                dark:false,
                colors: {
                    primary: "002885",
                },
            },
        },
    },

    components:{
        ...components
    },
    directives:directives,
    treeShake : true
});
const app = createApp(App);


app.use(pinia);
app.use(vuetify);
app.use(router);
app.mount('#app');

export default app;
